import styled from 'styled-components'

const BaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 100vw;
  position: relative;
  border-top: 8px solid ${props => props.theme.colors.yellow};
`

export const Container = styled(BaseContainer as any)`
  .Toastify {
    z-index: 100000;
  }
  .Toastify--animate {
    animation-duration: 1ms !important;
  }
  .Toastify__toast-container {
    width: 100%;
    top: 0;
    left: 0;
    transform: none;
  }
  .Toastify__toast {
    width: 100%;
    padding: 0;
    margin-bottom: 0;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
  }
  .Toastify__toast-body {
    font-size: 1.25em;
    padding: 0;
    margin: 0;
  }
  .Toastify__toast--warning {
    background-color: ${props => props.theme.colors.yellow100};
  }
  .Toastify__toast--success {
    background-color: ${props => props.theme.colors.green100};
  }
  .Toastify__toast--error {
    background-color: ${props => props.theme.colors.red100};
    position: fixed;
    z-index: 1;
  }
`

// @media (min-width: ${props => props.theme.screenSize.mobile}) {
//   width: ${props => props.theme.screenSize.mobile};
// }
// @media (min-width: ${props => props.theme.screenSize.tablet}) {
//   width: ${props => props.theme.screenSize.tablet};
// }
// @media (min-width: ${props => props.theme.screenSize.computer}) {
//   width: ${props => props.theme.screenSize.computer};
// }
